import * as React from 'react'
import { StyleSheet, View } from 'react-native'
import { FontAwesomeIcon, findIconDefinition } from '@purposity/icons'
import { snapYellow, originalBlack } from '@themes/Colors'

const SIZE = 16

export const YellowCheck = () => (
  <View style={styles.container}>
    <View style={styles.text}>
      <FontAwesomeIcon
        icon={findIconDefinition({ prefix: 'fas', iconName: 'check-circle' })}
        color={snapYellow}
      />
    </View>
    <View style={styles.background} />
  </View>
)

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    height: SIZE,
    width: SIZE,
  },
  text: { fontSize: SIZE, zIndex: 10, color: snapYellow },
  background: {
    width: SIZE - 4,
    height: SIZE - 4,
    position: 'absolute',
    zIndex: 9,
    borderRadius: SIZE / 2,
    backgroundColor: originalBlack,
  },
})
